import React, { useState, useEffect } from "react";
import Header from "@img/HeaderKerja.png";
import FloatingMenu from "../components/FloatingMenu";
import DOMPurify from "dompurify";

const cardClasses =
  "bg-white p-4 rounded-lg shadow-md flex items-start cursor-pointer";

const JobCard = ({ logo, title, location, system, category, onClick }) => {
  return (
    <div className={cardClasses} onClick={onClick}>
      <img
        src={`https://cms.okoce.net/storage/${logo}`}
        alt="Company Logo"
        className="w-20 max-h-20 mr-4 object-cover rounded-full"
      />
      <div>
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-zinc-800">{location}</p>
        <div className="flex gap-x-4">
          <div className="mt-4 bg-blue-200 px-3 py-2 rounded-md">
            <p className="text-[#1c75ac]">{system}</p>
          </div>
          <div className="mt-4 bg-green-200 px-3 py-2 rounded-md">
            <p className="text-green-500">{category}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const JobList = ({ onJobClick }) => {
  const [datas, setData] = useState([]);

  useEffect(() => {
    fetchDataPeluangKerja();
  }, []);

  const fetchDataPeluangKerja = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/job-opportunities"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data peluang kerja");
      }
      const data = await response.json();
      const PelKerData = data.data;
      PelKerData.sort((a, b) => b.id - a.id);
      setData(PelKerData);
    } catch (error) {
      setData([]);
    }
  };
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  return (
    <div>
      {datas.map((data) => (
        <div className="mt-0" key={data.id}>
          <div className="space-y-4 mt-5">
            <JobCard
              logo={data.image}
              title={data.title}
              location={data.location}
              system={capitalizeFirstLetter(data.system)}
              category={data.category?.toUpperCase()}
              onClick={() => onJobClick(data.id)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

const PeluangKerja = () => {
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [jobDetails, setJobDetails] = useState(null);

  useEffect(() => {
    if (selectedJobId !== null) {
      fetchJobDetails(selectedJobId);
    }
  }, [selectedJobId]);

  const fetchJobDetails = async (id) => {
    try {
      const response = await fetch(
        `https://cms.okoce.net/api/admin/job-opportunities/${id}`
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil detail peluang kerja");
      }
      const data = await response.json();
      setJobDetails(data.data);
    } catch (error) {
      setJobDetails(null);
    }
  };

  const handleJobClick = (id) => {
    setSelectedJobId(id);
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const sanitizedDescription = jobDetails
    ? DOMPurify.sanitize(jobDetails.description)
    : "";

  return (
    <>
      <section
        className="mt-[4em] bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${Header})`,
          width: `100%`,
          height: `100%`,
          backgroundSize: `cover`,
        }}
      >
        <div className="px-4 mx-auto max-w-screen-xl text-center py-24 lg:py-56">
          <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">
            Yuk, Mulai Gabung dan Dapatkan Hasil Tambahan dengan daftar
          </h1>
          <p className="mb-8 text-lg font-normal text-gray-300 lg:text-xl sm:px-16 lg:px-48">
            Fondasi kami, idemu, bersama-sama kita maju dan berkembang untuk
            menciptakan masa depan bersama yang lebih cerah.
          </p>
        </div>
      </section>

      <div className="w-full justify-around md:flex-row p-4 bg-gray-100 mobile:grid mobile:grid-cols-1 mobile:grid-flow-row lg:flex">
        <div className="mobile:max-w-[30rem] mobile:text-sm lg:min-w-[29rem] lg:p-4">
          <JobList onJobClick={handleJobClick} />
        </div>
        <div className="bg-white mt-10 rounded-xl flex items-center justify-center mobile:max-w-96 lg:min-w-[60%] lg:h-auto">
          {jobDetails ? (
            <div className="w-full h-full text-zinc-400">
              <div className="mobile:ml-0 mobile:px-4 lg:mt-10 lg:ml-2 lg:pr-16 lg:pl-14">
                <img
                  src={`${process.env.REACT_APP_API_URL}/${jobDetails.image}`}
                  alt={jobDetails.image}
                  className="w-full rounded-2xl max-h-56 sm:max-h-72 md:h-80 lg:h-96 xl:h-[500px] mt-8"
                />
                <h3 className="text-3xl mt-16 ml-1 font-bold text-center text-black mb-6">
                  {jobDetails.title}
                </h3>
                <p className="text-lg mt-1 ml-1 font-normal text-black">
                  <span className="font-bold">Lokasi: </span>
                  {jobDetails.location}
                </p>
                <p className="text-lg mt-1 ml-1 font-normal text-black">
                  <span className="font-bold">Kategori Kerja: </span>
                  {jobDetails.category?.toUpperCase()}
                </p>
                <p className="text-lg mt-1 ml-1 font-normal text-black">
                  <span className="font-bold">Sistem Kerja: </span>
                  {capitalizeFirstLetter(jobDetails.system)}
                </p>
                <p className="text-lg ml-1 font-normal text-black mb-4">
                  <span className="font-bold">Periode Pendaftaran: </span>
                  {jobDetails.period}
                </p>
                <div className="w-full mt-10 mr-32 mb-10">
                  <div
                    className="text-lg mt-3 ml-1 font-normal text-black"
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                  />
                </div>
                <a href={jobDetails.url}>
                  <button
                    type="button"
                    className="text-white bg-[#1c75ac] hover:bg-blue-700 focus:ring-4 focus:ring-[#1c75ac] font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-10"
                  >
                    Daftar Sekarang
                  </button>
                </a>
              </div>
            </div>
          ) : (
            <p className="text-lg font-normal text-black">
              Pilih pekerjaan untuk melihat detailnya
            </p>
          )}
        </div>
      </div>

      <FloatingMenu />
    </>
  );
};

export default PeluangKerja;
